import dayjs from 'dayjs';
import { useCallback } from 'react';
import { healthCheckOrderPerformUrl } from '@app/definition/API';
import apiClient from '@root/src/app/network/apiClient';
import Lang from '@lang/en';
import showNotification from '@root/src/app/designSystem/toastNotification/selectToast';

const getPatchData = () => {
  const now = dayjs().valueOf();
  return {
    performedAt: now,
  };
};

const useStartTimer = (): {
  startTimer: (id: number) => Promise<void>;
} => {
  const startTimer = useCallback(async (id: number): Promise<void> => {
    const url = healthCheckOrderPerformUrl.replace('%id%', String(id));
    const patchData = getPatchData();

    const result = await apiClient.patch(url, patchData);

    if (result.status === 200) {
      showNotification({
        text: Lang.healthCheckTimerStartedNotification,
        type: 'default',
      });
    }
  }, []);

  return {
    startTimer,
  };
};

export default useStartTimer;
